export const trilingualModel = {
  title: "Modelo Trilingüe Progresivo",
  subtitle: "Inmersión en inglés que crece con cada etapa",
  stages: {
    infantil: {
      title: "Infantil (3-6 años)",
      percentage: "40%",
      description: "Introducción natural al inglés en rutinas, juegos y actividades cotidianas"
    },
    cycle1: {
      title: "Primaria Ciclo 1 (6-9 años)",
      percentage: "45%",
      description: "Áreas no lingüísticas como Science y Arts en inglés, consolidando la base comunicativa"
    },
    cycle2: {
      title: "Primaria Ciclo 2 (9-12 años)",
      percentage: "50%",
      description: "Mitad del currículum en inglés, con fluidez completa en contextos académicos y sociales"
    }
  },
  footer: "Español y Gallego están presentes en todas las etapas, garantizando el dominio de las tres lenguas"
};
